export default __webpack_public_path__ + "static/media/intro.59970f3c.png";